// BreadcrumbList JSON-LD — Schema.org type that renders as a clickable
// breadcrumb trail in Google SERPs (richer-result eligibility).
//
// Pages call `buildBreadcrumbJsonLd([…])` with an ordered list and pass
// the result into `<JsonLdScript data={…} />`. Single-segment trails
// are pointless (Google ignores them); helpers below short-circuit.

import { resolveCanonicalOrigin } from '../origin';

import type { JsonLdNode, JsonLdPayload } from './types';

export interface BreadcrumbItem {
  /** Human-readable label, e.g. "Markets" or "Trump 2026". */
  name: string;
  /** Path relative to canonical origin, e.g. `/markets`. The current
   *  page (last item) MAY pass `null` here — Google treats the final
   *  item as the current location and doesn't require a URL. */
  path: string | null;
}

export function buildBreadcrumbJsonLd(items: readonly BreadcrumbItem[]): JsonLdPayload {
  if (items.length < 2) return null;
  const origin = resolveCanonicalOrigin();
  const node: JsonLdNode = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      ...(item.path !== null ? { item: new URL(item.path, origin).toString() } : {}),
    })),
  };
  return node;
}
